<template>
    <div class="chatWrap wrap">

        <div class="back">
            <ButtonWithLoading
                classes="btnBack"
                :loading="quitChatLoading"
                title="Back"
                loaderColor="blue"
                @click="quitChat"
            />
        </div>

        <div class="content">

            <div class="wrap">
                <vue-custom-scrollbar ref="scrollArea" class="scrollArea" :settings="scrollSettings">

                    <div class="timeWrap center">
                        <span>{{ formatDate() }}</span>
                    </div>

                    <div class="messages">

                        <div
                            :key="index"
                            v-for="(res, index) in chatResponses"
                            class="message"
                            :class="{ 'you' : res.user, 'chat' : !res.user }"
                        >
                            <div v-if="res.text">
                                <span>{{ res.text }}</span>
                            </div>
<!--                            <div  v-if="chatDelay && !res.user">-->
<!--                                <span><PulseLoader  size="7px"  color="#273845" /></span>-->
<!--                            </div>-->
                        </div>
                        <div v-if="chatDelay" class="message chat"><PulseLoader  size="7px"  color="#273845" /></div>
                    </div>

                 </vue-custom-scrollbar>
            </div>

            <div class="yourMessage">
                <img class="clip" src="/assets/img/clip.svg" alt="clip">
                <input
                    placeholder="Type a message.."
                    autofocus="true"
                    v-model="userMessage"
                    type="text"
                    @keyup.enter="submitMessage"
                />
                <ButtonWithLoading
                    classes="btn btnThin sendMessage"
                    :loading="messageSending"
                    :title="$mq=='lg' ? 'Send reply' : 'Send'"
                    @click="submitMessage"
                />
            </div>
        </div>

    </div>
</template>

<script>
    import vueCustomScrollbar from 'vue-custom-scrollbar';
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
    import ButtonWithLoading from '../../components/form/ButtonWithLoading';
    import { asyncForEach, waitFor } from '../../helpers/misc';
    import moment from 'moment';

    export default {
        props: {
            sessionId: {
              type: String,
            },
        },
        data() {
          return {
              userMessage: '',
              messageSending: false,
              chatStartTime: moment.now(),
              chatDelay: false,
              chatResponses: [],
              scrollSettings: {
                maxScrollbarLength: 270
              },
              quitChatLoading: false
          }
        },

        components : { ButtonWithLoading, vueCustomScrollbar, PulseLoader },

        mounted() {
            //send first message from chatbot
            axios.post('/api/support/send-message', { sessionId: this.sessionId, message: '' }).then( res => {
                this.chatResponses = [...this.chatResponses, ...res.data.chat.output.generic];
            }).catch(error =>{
                console.log(error);
            });
        },

        beforeDestroy() {
          this.quitChat();
        },

        methods: {
            formatDate() {
                return moment(this.chatStartTime).calendar(moment());
            },
            submitMessage: function () {
                if (this.userMessage) {
                    this.messageSending = true;
                    axios.post('/api/support/send-message', { sessionId: this.sessionId, message: this.userMessage }).then( res => {

                        this.chatResponses = [...this.chatResponses, { text: this.userMessage, user: true }];
                        this.userMessage = '';
                        this.messageSending = false;

                        asyncForEach(res.data.chat.output.generic, async (res) => {

                            await waitFor(3000);
                            this.chatDelay = true;
                            await waitFor(3000);
                            //this.chatResponses.pop();
                            this.chatDelay = false;

                            this.chatResponses.push(res);
                            if (res.response_type === 'pause') {
                               // await waitFor(res.time);
                               // this.chatResponses.pop();
                            }
                        });

                    }).catch(error => {
                        console.log(error);
                    });
                }
            },
            quitChat: function () {
                if (this.sessionId) {
                    this.quitChatLoading = true;

                    axios.post('/api/support/delete-session', { sessionId: this.sessionId }).then( res => {
                        this.quitChatLoading = false;

                        if (!res.data.error) {

                            this.$emit('quitChat', this.sessionId);
                            //TODO save messages in db?


                            if (this.chatResponses.length > 1) {
                                this.$store.dispatch('saveChatSession', {
                                    time: this.chatStartTime ,
                                    chatData: this.chatResponses,
                                    sessionId: this.sessionId
                                });

                                axios.post('api/support/chat/save',{
                                    time: this.chatStartTime ,
                                    chatData: this.chatResponses,
                                    sessionId: this.sessionId
                                });
                            }
                            this.chatResponses = [];
                        }
                    }).catch(error =>{
                        console.log(error);
                    });
                }
            }
        },
        watch: {
            chatResponses: function () {
                Vue.nextTick(() => {
                    if (this.chatResponses.length) {
                        //scroll chat area to bottom
                        if (this.$mq === 'lg') {
                            const scrollArea = this.$refs.scrollArea.$el;
                            scrollArea.scrollTop = scrollArea.scrollHeight - scrollArea.clientHeight;
                        } else {
                            window.scrollTo(0,document.body.scrollHeight);
                        }
                    }
                });
            }
        }

    }
</script>
